"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var PremiumIcon = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 14 12", fill: "currentColor", width: size || '14', height: size || '12' }, props),
        React.createElement("path", { fill: "currentColor", d: "M14 0l-1 9H1L0 0h1c.75 0 1 3 3 3s2-3 2-3h2s0 3 2 3 2.25-3 3-3h1zm-1 12H1v-1h12v1z" })));
};
PremiumIcon.displayName = 'PremiumIcon';
exports.default = PremiumIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PremiumIcon.js.map